import styled from 'styled-components'

const FirstLevelTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.color.base.c9};
`

export default FirstLevelTitle
